import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const UkFlag = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 18"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <g clipPath="url(#uk-flag_svg__a)">
                <rect width={24} height={18} fill="#21468A" rx={2} />
                <path stroke="#fff" strokeWidth={4} d="M0 18 23 0M1 0l23 18M12 0v18M0 9h24" />
                <path stroke="#AE1C28" d="M0 18 23 0M1 0l23 18" />
                <path stroke="#AE1C28" strokeWidth={2.5} d="M12 0v18M0 9h24" />
            </g>
            <rect width={23} height={17} x={0.5} y={0.5} stroke="#1F1D47" strokeOpacity={0.12} rx={1.5} />
            <defs>
                <clipPath id="uk-flag_svg__a">
                    <rect width={24} height={18} fill="#fff" rx={2} />
                </clipPath>
            </defs>
        </svg>
    </IconWrapper>
)
